import React,{useState,useEffect} from "react";
import { CardComponent, SelectComponent, TitleComponent, ButtonActionComponent,TableComponent, SelectComponentMulti, ButtonGenerateExcelAuditComponent } from "../../../components/pages";
import { useGetApiWs } from "../../../hooks";
import { api, apiConfig } from "../../../util/api";

const SellPointsStatus = (props) =>{
    const urlCustomer = useGetApiWs('admin', 'entity', 'company-get');
    const urlCustonerInfo = useGetApiWs('admin', 'entity', 'customer-get');
    const urlFilter = useGetApiWs('admin', 'entity', 'analysis-sellpoints-get');

    const [customers, setCustomers] = useState([]);
    const [category, setCategory] = useState([]);
    const [channels, setChannels] = useState([]);
    const [cities, setCities] = useState([]);
    const [measurement, setMeasurement] = useState([]);

    const [customerIsLoading, setCustomerIsLoading] = useState(true);
    const [categoryIsLoading, setCategoryIsLoading] = useState(true);
    const [channelsIsDisabled, setChannelsIsDisabled] = useState(false);
    const [channelsIsLoading, setChannelsIsLoading] = useState(true);
    const [measurementLoading, setMeasurementIsLoading] = useState(true);
    const [citiesIsLoading, setCitiesIsLoading] = useState(true);

    const [lbCustomer, setLbCustomer] = useState(null);
    const [lbCategory, setLbCategory] = useState(null);
    const [lbChannels, setLbChannels] = useState(null);
    const [lbMeasurement, setLbMeasurement] = useState(null);
    const [lbCities, setLbCities] = useState(null);

    const [tbHeadings, setTbDataHeadings] = useState([]);
    const [tbData, setTbData] = useState([]);
    const [tbColumns, setTbColumns] = useState([]);
    const [tbPending, setTbPending] = useState(false);

    const [btnExports, setBtnExports] = useState(false);

    const fetchCustomers = async () => {
        const customers = await api().post(urlCustomer, { company_type_code: 'CM-CUST' }, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.company_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setCustomers(options);
        setCustomerIsLoading(false);
        CustomerChange({ 'value': 3, 'label': 'ALICORP' })
    }

    const fetchCategory = async (customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'categories';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const cWorkOrders = await api().post(urlCustonerInfo, ob, apiConfig());
        if (cWorkOrders.status === 200 && cWorkOrders.data.status === 'success') {
            var options = cWorkOrders.data.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.category_id;
                rObj['label'] = obj.category_name;
                return rObj;
            })
            setCategory(options);
        }
        setCategoryIsLoading(false);
    }

    const fetchChannels = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'channels';
        if (props.test != null || props.test != undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const channels = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = channels.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.channel_id;
            rObj['label'] = obj.name;
            return rObj;
        });
        setChannels(options);
        setChannelsIsLoading(false);
    }

    const fetchCities = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'cities';
        if (props.test !== null || props.test !== undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const customers = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.city_id;
            rObj['label'] = obj.name;
            return rObj;
        });
        setCities(options);
        setCitiesIsLoading(false);
    }

    const fetchMeasurement = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'measurements';
        if (props.test !== null || props.test !== undefined) {
            ob['is_test'] = 1;
        } else {
            ob['is_test'] = 1;
        }
        const measurement = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = measurement.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.measurement_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setMeasurement(options);
        setMeasurementIsLoading(false);
    }

    const CustomerChange = async vals => {
        setLbCustomer(vals);
        if (vals === null) {
            setCategory([]);
            setLbCategory(null);
        } else {
            setCategory([]);
            setLbCategory(null);
            fetchCategory(vals.value);
        }
    }

    const CategoryChange = async vals => {
        setLbCategory(vals);

        if (vals != null) {
            fetchChannels(vals.value, lbCustomer.value);
            fetchMeasurement(vals.value, lbCustomer.value);
            fetchCities(vals.value, lbCustomer.value);
        }
    }

    const MeasurementChange = async vals => {
        setLbMeasurement(vals);
    }

    const ChannelChange = async vals=>{
        setLbChannels(vals);
    }
    const CityChange = async vals => {
        setLbCities(vals);
    }

    const Filter = () => {
        setBtnExports(false);
        fetchFilters();
    }

    const fetchFilters = async () => {
        if (lbCategory != null && lbChannels != null ) {
            setTbPending(true);
            const ob = {};
            ob['customer_id'] = lbCustomer.value;
            ob['category_id'] = lbCategory.label + '|' + lbCategory.value + '|';
            //ob['channels'] = lbChannels.label + '|' + lbChannels.value + '|';

            const chan = lbChannels.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const mes = lbMeasurement.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const cit = lbCities.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            
            ob['measurements'] = mes.join(','); 
            ob['cities'] = cit.join(',');
            ob['channels'] = chan.join(',');
            
            var headers = [];
            const res = await api().post(urlFilter, ob, apiConfig());
            if (res.data.status === 'success') {
                let colum = [];
                if (res.data.response.length > 0) {
                    const head = res.data.response[0]
                    headers = Object.keys(head)
                    for (var h in headers) {
                        colum.push({
                            name: headers[h], selector: headers[h], sortable: false, wrap: true
                        })
                    }
                    setBtnExports(true);
                    setTbColumns(colum);
                    setTbData(res.data.response);
                    setTbPending(false);
                } else {
                    setBtnExports(false);
                    setTbColumns([]);
                    setTbData([]);
                    setTbPending(false);
                }
            }
        } else {
            return null;
        }
    }
    
    useEffect(() => {
        fetchCustomers()
    }, [])
    return(
            <div>
            <TitleComponent title="ESTADO DE PUNTO DE VENTA" />
            <div className="pt-3">
                <CardComponent header={null} footer={null}>
                    <div className="bg-white p-2">
                        <div className="grid md:grid-cols-4 lg:grid-cols-4 items-center gap-4">
                            <SelectComponent onChange={CustomerChange} options={customers} value={lbCustomer} isLoading={customerIsLoading} label="Clientes" isDisabled={false} />
                            <SelectComponent onChange={CategoryChange} options={category} value={lbCategory} isLoading={categoryIsLoading} label="Categoría" />
                            <SelectComponentMulti onChange={CityChange} options={cities} value={lbCities} isLoading={citiesIsLoading} label="Ciudades"/>
                            <SelectComponentMulti onChange={ChannelChange} value={lbChannels} options={channels} isLoading={channelsIsLoading} isDisabled={channelsIsDisabled} label="Canales" />
                            <SelectComponentMulti onChange={MeasurementChange} options={measurement} value={lbMeasurement} isLoading={measurementLoading} label="Medición" />
                        </div>
                    </div>
                </CardComponent>
            </div>
            <div className="p-2 justify-items-end grid">
                <div className="space-x-4">
                    <ButtonActionComponent name="GENERAR REPORTE" onClick={Filter} />
                    {/* {(btnExports) ? <ButtonGenerateExcelAuditComponent name="EXPORTAR EXCEL" onClick={props.createDataExcel} /> : null}
                 */}</div>
            </div>

            <div id="list" className="list pt-3">
                <CardComponent header={<h4 className="">ESTADO DE PUNTO DE VENTA</h4>} footer={null}>
                    <div className="bg-white">
                        <div>
                        </div>
                        <TableComponent
                            keyField="work_order_id"
                            columns={tbColumns}
                            headItem={tbHeadings}
                            data={tbData}
                            pending={tbPending}
                            highlightOnHover={true}
                        />
                    </div>
                </CardComponent>
            </div>
        </div>
    )
}
export default SellPointsStatus;